var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-wrapper relative border border-secondary-20 p-4 rounded-lg"},[_c('img',{staticClass:"qr-code",attrs:{"src":_vm.qrCodeImageUrl}}),(_vm.isLoading)?_c('aha-spinner',{staticClass:"loading-layer",attrs:{"variant":"dark"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }